
/* ------------------- General --------------------*/

export const abriv_months = ["Jan", "Feb", "Mar","Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const name_months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export const HSAMaxImageSize = (parseFloat(5.5) * 1024 * 1024);

/* ------------------- HSAFileNameFormat ------------------ */
export const HSAFileNameFormat = (input) =>{
    return input.replace(/[^a-zA-Z0-9-_]/g, '');
}

/* ------------------- HSAPlans --------------------*/
export const HSAPlans = {
    group: {
        name: "HSA Group",
        code: 1071,
        price: 335.00,
        renewprice: 99.00
    },
    basic: {
        name: "HSA Basic",
        code: 1051,
        price: 249.00
    },
    plus: {
        name: "HSA Plus",
        code: 1081,
        price: 499.00
    },
    deluxe: {
        name: "HSA Deluxe",
        code: 2000,
        price: 699.00
    },
};

export const OfferedHSAPlans = {
    '1071': {
        name: "HSA Group",
        shortname: 'group',
        code: 1071,
        price: 335.00,
        renewprice: 99.00
    },
    '1051': {
        name: "HSA Basic",
        shortname: 'basic',
        code: 1051,
        price: 249.00
    },
    '1081': {
        name: "HSA Plus",
        shortname: 'plus',
        code: 1081,
        price: 499.00
    },
    '2000': {
        name: "HSA Deluxe",
        shortname: 'deluxe',
        code: 2000,
        price: 699.00
    },
};

export const HSAPlanList = {
    1071: {
        name: "HSA Group",
    },
    1051: {
        name: "HSA Basic",
    },
    1081: {
        name: "HSA Plus",
    },
    2000: {
        name: "HSA Deluxe",
    },
    1: {
        name: "HSA Family",
    },
    2: {
        name: "HSA Sole",
    },
    3: {
        name: "HSA Legacy Group Plan",
    },
    4: {
        name: "HSA Small Group",
    },
    5: {
        name: "HSA Small Group",
    },
    8: {
        name: "HSA Legacy Group Plan - Uincorporated",
    },
    10: {
        name: "HSA Elite",
    },
    13 : {
        name: "HSA Online Group",
    },
    21: {
        name: "HSA Family",
    },
    22: {
        name: "HSA Single",
    },
    23: {
        name: "HSA Sole Family",
    },
    24: {
        name: "HSA Single",
    },
    1011: {
        name: "HSA Single Inc",
    },
    1012: {
        name: "HSA Single Sole",
    },
    1021: {
        name: "HSA Family Inc",
    },
    1022: {
        name: "HSA Family Sole",
    },
    1031: {
        name: "HSA Classic Inc",
    },
    1032: {
        name: "HSA Classic Sole",
    },
    1061: {
        name: "HSA Plus",
    },
};

export const HSALimitPeriods = {
    '0': {
        name: ''
    },
    '1': {
        name: "Reset",
    },
    '2': {
        name: "Roll-over",
    }
};

export const LimitAmounts = {
    'HSAMax': 15000,
    'HSAMin': 250,
    'WSAMax': 15000,
    'WSAMin': 250,
}

//for wellness setup
export const WSACategoriesList = [
    'Nutrition',
	'Fitness',
	'Professional/Personal Development',
	'Personal/Family Interest',
	'Mental Health'
]

export const BenefitTypeByExplaination = {
  'Reset on plan year end':1,
  'Roll over on plan year end':2,
  'Reset every 12 months on Jan 1':3
}

export const getProductName = (product) => {
    if (product === 'employ') {
        return "Employee Benefits";
    }
    else if (product === 'incorp'){
        return 'Incorporated Individual';
    }
    else {
        return '';
    }
}

export const getHSAPlanName = (code) => {
    if (HSAPlanList[code] === undefined) {
        return "Invalid Plan";
    }
    else {
        return HSAPlanList[code].name;
    }
}

export const getOfferedPlanShortName = (code) => {
    if (OfferedHSAPlans[code] === undefined) {
        return "invalid";
    }
    else {
        return OfferedHSAPlans[code].shortname;
    }
}

export const getAllowedPlan = (code, isNotInsured) => {
    if(isNotInsured === 'Y'){
        switch (code.toString()){
            case HSAPlans.group.code.toString():
                return true;
            case HSAPlans.basic.code.toString():
                return true;
            case HSAPlans.plus.code.toString():
                return false;
            case HSAPlans.deluxe.code.toString():
                return false;
            default: return "Invalid Plan";
        }
    } else {
        return true
    }
}

export const getHSASetupPrice = (plancode) => {
    switch (plancode.toString()){
        case HSAPlans.group.code.toString():
            return "$" + HSAPlans.group.price.toFixed(2);
        case HSAPlans.basic.code.toString():
            return "$" + HSAPlans.basic.price.toFixed(2);
        case HSAPlans.plus.code.toString():
            return "$" + HSAPlans.plus.price.toFixed(2);
        case HSAPlans.deluxe.code.toString():
            return "$" + HSAPlans.deluxe.price.toFixed(2);
        default: return "Invalid Plan";
    }
}

export const getHSAPlanRenewalPrice = (plancode) => {
    switch (plancode.toString()){
        case HSAPlans.group.code.toString():
            return "$" + HSAPlans.group.renewprice.toFixed(2);
        case HSAPlans.basic.code.toString():
            return "$" + HSAPlans.basic.price.toFixed(2);
        case HSAPlans.plus.code.toString():
            return "$" + HSAPlans.plus.price.toFixed(2);
        case HSAPlans.deluxe.code.toString():
            return "$" + HSAPlans.deluxe.price.toFixed(2);
        default: return "Invalid Plan";
    }
}

export const getHSASetupPriceTaxes = (plancode, postalcode) => {
    switch (plancode.toString()){
        case HSAPlans.group.code.toString():
            return "$" + (HSAPlans.group.price * HSAProvinces[getProvince(postalcode)]['tax']).toFixed(2);
        case HSAPlans.basic.code.toString():
            return "$" + (HSAPlans.basic.price * HSAProvinces[getProvince(postalcode)]['tax']).toFixed(2);
        case HSAPlans.plus.code.toString():
        case HSAPlans.deluxe.code.toString():
            return "Included in plan price.";
        default: return "Invalid Plan";
    }
}

export const getHSAClaimTaxes = (plancode, postalcode) => {
    switch (plancode.toString()){
        case HSAPlans.group.code.toString():
            return (HSAProvinces[getProvince(postalcode)]['claims']);
        case HSAPlans.basic.code.toString():
        case HSAPlans.plus.code.toString():
        case HSAPlans.deluxe.code.toString():
            return "N/A";
        default: return "Invalid Plan";
    }
}
export const getHSAAdminFee = (plancode) => {
    switch (plancode.toString()){
        case HSAPlans.group.code.toString():
            return "8%";
        case HSAPlans.basic.code.toString():
        case HSAPlans.plus.code.toString():
        case HSAPlans.deluxe.code.toString():
            return "N/A";
        default: return "Invalid Plan";
    }
}
export const getHSASetupPriceTotal = (plancode, postalcode) => {
    switch (plancode.toString()){
        case HSAPlans.group.code.toString():
            return "$" + ((HSAPlans.group.price * HSAProvinces[getProvince(postalcode)]['tax']) + HSAPlans.group.price).toFixed(2);
        case HSAPlans.basic.code.toString():
            return "$" + ((HSAPlans.basic.price * HSAProvinces[getProvince(postalcode)]['tax']) + HSAPlans.basic.price).toFixed(2);
        case HSAPlans.plus.code.toString():
            return "$" + (HSAPlans.plus.price).toFixed(2);
        case HSAPlans.deluxe.code.toString():
            return "$" + (HSAPlans.deluxe.price).toFixed(2);
        default: return "Invalid Plan";
    }
}

export const getHSASetupPriceTaxesDesc = (plancode, postalcode) => {
    switch (plancode.toString()){
        case HSAPlans.group.code.toString():
            return " ("+HSAProvinces[getProvince(postalcode)]['setup']+")";
        case HSAPlans.basic.code.toString():
            return " ("+HSAProvinces[getProvince(postalcode)]['setup']+")";
        case HSAPlans.plus.code.toString():
            return "";
        case HSAPlans.deluxe.code.toString():
            return "";
        default:
            return "";
    }
}

// goes off PLAN_TYPE
export const familyPlans = [
  21, // HSA Family $299
  22, // HSA Single $199
  23, // HSA Sole Family $299
  24, // HSA Sole Single $199
  1011, // HSA Single Inc $199
  1012, // HSA Single Sole $199
  1021, // HSA Family Inc $299
  1022, // HSA Family Sole $299
  1031, // HSA Classic Inc $99
  1032, // HSA Classic Sole $199
  1051, // HSA Basic $249
  1061, // HSA Plus $399
  1081, // HSA Plus $499
  2000, // HSA Deluxe $699
];

// goes off CONTRACT_TYPE
export const noRenewalPlans = [
  1, 2, 3, 8, 10
];

// goes off CONTRACT_TYPE
export const claimOnlineContracts = [
  1, 2, 4, 5, 6, 7, 10, 11, 12, 13, 14, 20
];

// goes off CONTRACT_TYPE
export const groupPlans = [
  3, // Legacy Group Plan
  8, // Legacy Group Plan - Uincorporated
  13 // HSA Online Group
];

// goes off CONTRACT_TYPE
export const legacyPlans = [
  1, // family
  2, // sole
  10 // elite
];

export const onlineOnlyPlans = [1051,
1061,
1081,
2000,
1071];

/* ------------------- SignupCompanyTypes -------------------- */
export const SignupCompanyTypes = {
    incorp: {
        name: "Incorporated",
        code: 1
    },
    nonprofit: {
        name: "Not-for-Profit Organization",
        code: 3
    }
};

export const getSignupCompanyTypeName = (code) => {
    switch (code.toString()){
        case SignupCompanyTypes.incorp.code.toString():
            return SignupCompanyTypes.incorp.name;
        case SignupCompanyTypes.nonprofit.code.toString():
            return SignupCompanyTypes.nonprofit.name
        default: return "Invalid Company Type";
    }
}

export const SignupCompanyPlanYearEndTypes = {
    corporateFiscal: {
        name: "Corporate Fiscal Year End",
        code: 1
    },
    yearAfterEff: {
        name: "12 Months after Effective Date",
        code: 2
    },
    calendarYear: {
        name: "Calendar Year End Date",
        code: 3
    }
};

export const getSignupCompanyPlanYearEndTypeName = (code) => {
    switch (code.toString()){
        case SignupCompanyPlanYearEndTypes.corporateFiscal.code.toString():
            return SignupCompanyPlanYearEndTypes.corporateFiscal.name;
        case SignupCompanyPlanYearEndTypes.yearAfterEff.code.toString():
            return SignupCompanyPlanYearEndTypes.yearAfterEff.name
        case SignupCompanyPlanYearEndTypes.calendarYear.code.toString():
            return SignupCompanyPlanYearEndTypes.calendarYear.name
        default: return "Invalid Company Plan Year End Type";
    }
}

/* ------------------- Province -------------------- */
export const Provinces = {
  "AB":{ "name":"Alberta", "abbr": "AB", "licenced":true, "tax": 0.05},
  "BC":{ "name":"British Columbia", "abbr": "BC", "licenced":true, "tax": 0.05 },
  "SK":{ "name":"Saskatchewan", "abbr": "SK", "licenced":true, "tax": 0.05 },
  "MB":{ "name":"Manitoba", "abbr": "MB", "licenced":true, "tax": 0.05 },
  "ON":{ "name":"Ontario", "abbr": "ON", "licenced":true, "tax": 0.13 },
  "QC":{ "name":"Quebec", "abbr": "QC", "licenced":false, "tax": 0.05},
  "NB":{ "name":"New Brunswick", "abbr": "NB", "licenced":false, "tax": 0.15 },
  "NS":{ "name":"Nova Scotia", "abbr": "NS", "licenced":true, "tax": 0.14 },
  "NL":{ "name":"Newfoundland and Labrador", "abbr": "NL", "licenced":false, "tax": 0.15 },
  "NT":{ "name":"Northwest Territories", "abbr": "NT", "licenced":false, "tax": 0.05 },
  "NU":{ "name":"Nunavut", "abbr": "NU", "licenced":false, "tax": 0.05 },
  "PE":{ "name":"Prince Edward Island", "abbr": "PE", "licenced":false, "tax": 0.15 },
  "YT":{ "name":"Yukon", "abbr": "YT", "licenced":false, "tax": 0.05 },
}

export const ServicedProvinces = {
    "AB":{ "name":"Alberta", "abbr": "AB", "licenced":true, "tax": 0.05},
    "BC":{ "name":"British Columbia", "abbr": "BC", "licenced":true, "tax": 0.05 },
    "SK":{ "name":"Saskatchewan", "abbr": "SK", "licenced":true, "tax": 0.05 },
    "MB":{ "name":"Manitoba", "abbr": "MB", "licenced":true, "tax": 0.05 },
    "ON":{ "name":"Ontario", "abbr": "ON", "licenced":true, "tax": 0.13 },
    "NS":{ "name":"Nova Scotia", "abbr": "NS", "licenced":true, "tax": 0.14 }
}

export const HSAProvinces = {
    "AB":{'tax':0.05,'setup':'5% GST','membership':'5% GST','claims':'5% GST on admin fee','premium':'0%','insurance':'0%'},
    "BC":{'tax':0.05,'setup':'5% GST','membership':'5% GST','claims':'5% GST on admin fee','premium':'0%','insurance':'0%'},
    "MB":{'tax':0.05,'setup':'5% GST','membership':'5% GST','claims':'5% GST on admin fee','premium':'0%','insurance':'0%'},
    "SK":{'tax':0.05,'setup':'5% GST','membership':'5% GST','claims':'5% GST on admin fee','premium':'0%','insurance':'0%'},
    "ON":{'tax':0.13, 'setup':'13% HST','membership':'13% HST','claims':'8% RST on Claimed Amount.\n2% Premium Tax on Claimed Amount + Admin Fee.\n13% HST on the Admin Fee.','premium':'2% on claimed amount plus admin fees','insurance':'8% RST'},
    "NS":{'tax':0.14,'setup':'14% HST','membership':'14% HST','claims':'14% HST on admin fee'}
}

export const servicedPostalCode = (postalcode) => {
    if(HSAProvinces[getProvince(postalcode)] !== undefined){
        return true;
    }
    return false;
}

export const getProvinceTax = (provinceAbriv) => {
    if(provinceAbriv === '' || !Provinces.hasOwnProperty(provinceAbriv.toUpperCase()))
        return 0.05;
    return Provinces[provinceAbriv]['tax'];
}

export const getProvince = (postalcode) => {
    switch (postalcode.toString().toUpperCase().charAt(0)){
        case 'B':
            return 'NS';
        case 'K':
        case 'L':
        case 'M':
        case 'N':
        case 'P':
            return 'ON';
        case 'R':
            return 'MB';
        case 'S':
            return 'SK';
        case 'T':
            return 'AB';
        case 'V':
            return 'BC';
        case 'X':
            return 'NT';
        case 'Y':
            return 'YT';
        case 'A':
            return 'NL';
        case 'C':
            return 'PE';
        case 'E':
            return 'NB';
        case 'G':
        case 'H':
        case 'J':
            return 'QC';
        default:
            return '';
    }
}

/* ------------------- Helper Functions -------------------- */
export function checkNewEmployee(user) {

  if(user === undefined || Object.keys(user).length === 0 || (user.NON_MEMBER_ADMIN_ONLY && user.NON_MEMBER_ADMIN_ONLY === 'Y') ) {
    return false;
  }

  if(user.TYPE !== 'EMPLOYEE') return false;

  if(
    user.HSA_EMPLOYER_AGREEMENT === null &&
    user.USERNAME === 'PHSPW' &&
    groupPlans.includes(parseInt(user.CONTRACT_TYPE))
  ) return true;

  return false;

}

/* ------------------------------------------------------- */
export function setPayableClass(classes, amount, payableAmount){
  switch(true){
      case (parseFloat(payableAmount) == 0):
          return classes.insufficient;
      case (parseFloat(amount) > parseFloat(payableAmount)):
          return classes.partial;
      default:
          return classes.full;
  }
}


export function getBenefitTypeNumberByDescription(benefitTypeDescription){
  switch(benefitTypeDescription){
    case ('Reset on plan year end'):
      return parseInt(1);
    case ('Roll over on plan year end'):
      return parseInt(2);
    case ('Reset every 12 months on Jan 1'):
      return parseInt(3);
    default:
      return parseInt(1);
  }
}

/* ------------------- Validation ------------------------ */
export const Validate = ( value, rule ) => {

    let isValid = true;

    if ( !rule ) {
        return true;
    }

    if ( rule === 'required' ) {
        isValid = value.toString().trim() !== '' && isValid;
    }

    if ( rule === 'isChecked' ) {
        isValid = (value.toString() === 'true') && isValid;
    }

    if ( rule === 'minLength' ) {
        isValid = value.length >= rule.minLength && isValid;
    }

    if ( rule === 'maxLength' ) {
        isValid = value.length <= rule.maxLength && isValid;
    }

    if ( rule === 'isEmail' ) {
        const pattern = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
        isValid = pattern.test( value ) && isValid;
    }

    if ( rule === 'hasNumber' ) {
        const pattern = /\d/;
        isValid = pattern.test( value ) && isValid;
    }

    if ( rule === 'isNumeric' ) {
        const pattern = /^\d+$/;
        isValid = pattern.test( value ) && isValid;
    }

    if ( rule === 'isTelephone' ) {
        const pattern = /^(\+1\s?)?\(?\d{3}\)?[\-. ]?\d{3}[\-. ]?\d{4}$/;
        isValid = pattern.test( value ) && isValid;
    }

    if (rule === 'isPostal') {
        const pattern = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
        isValid = pattern.test( value ) && isValid;
    }

    if (rule === 'isAllowedProvince') {
        const inAllowed = Object.keys(HSAProvinces).includes(value);
        isValid = inAllowed && isValid;
    }

    if (rule === 'isProvince') {
        const inAllowed = Object.keys(Provinces).includes(value);
        isValid = inAllowed && isValid;
    }

    if ( rule === 'isISOFormat' ) {
        const pattern = /^\d{4}-\d{2}-\d{2}$/ ;
        isValid = pattern.test( value ) && isValid;
    }

    if ( rule === 'isMonthDay' ) {
        const pattern = /^\d{2}-\d{2}$/ ;
        isValid = pattern.test( value ) && isValid;
    }

    if ( rule === 'isMonthAbbrDay' ) {
        const pattern = /^\w{3}-\d{2}$/ ;
        isValid = pattern.test( value ) && isValid;
    }

    if (rule === 'isServiced'){
        isValid = servicedPostalCode(value) && isValid;
    }

    if ( rule === 'isName' ) {
        const pattern = /^[\w'\-,.]*[^_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]*$/ ;
        isValid = pattern.test( value ) && isValid;
    }

    if ( rule === 'isDate' ) {

        isValid = !isNaN(Date.parse(value)) && isValid;
    }

    if ( rule === 'isOver18' ) {
        let isOlderThan18 = false;
        if( !isNaN(Date.parse(value)) ){
            let birthdate = new Date(value);
            let birthdate18 = new Date(value);
            birthdate18.setFullYear(birthdate18.getFullYear() + 18);
            let maxage = new Date();
            maxage.setFullYear(maxage.getFullYear() - 70);
            isOlderThan18 = new Date() > birthdate18 && birthdate > maxage;
        }
        isValid = !isNaN(Date.parse(value)) && isOlderThan18 && isValid;
    }

    return isValid;
}

/*----------------------- Claim Calculation Functions ----------------------------------*/
/* --------------------------------- Validation -------------------------------------- */
export const CalculateClaim = ( balance, totalClaimed, previousYearBalance, previousYearTotalClaimed, adminFee, coPay, gst, hst, rst, pst, prem) => {

  let claimTotals = {
    payableAmount: 0, // current year payable amount
    previousYearPayableAmount: 0, // previous  year payable amount
    totalPayableAmount: 0, // current year and previous year total payable amount
    adminFeeAmount: 0,
    coPayAmount: 0,
    gstAmount: 0,
    hstAmount: 0,
    rstAmount: 0,
    pstAmount: 0,
    premAmount: 0,
    totalAmount: 0
  };

  if(parseFloat(coPay) > 0) {

    claimTotals.coPayAmount = (parseFloat(totalClaimed) * coPay/100);

    claimTotals.previousYearCoPayAmount = (parseFloat(previousYearTotalClaimed) * coPay/100);

    claimTotals.payableAmount = (parseFloat(balance) > parseFloat(totalClaimed)-parseFloat(claimTotals.coPayAmount))? parseFloat(totalClaimed)-parseFloat(claimTotals.coPayAmount) : parseFloat(balance);

    claimTotals.previousYearPayableAmount = (parseFloat(previousYearBalance) > parseFloat(previousYearTotalClaimed)-parseFloat(claimTotals.previousYearCoPayAmount))? parseFloat(previousYearTotalClaimed)-parseFloat(claimTotals.previousYearCoPayAmount) : parseFloat(previousYearBalance);

  } else {

    claimTotals.payableAmount = (parseFloat(balance) > parseFloat(totalClaimed))? parseFloat(totalClaimed) : parseFloat(balance);

    claimTotals.previousYearPayableAmount = (parseFloat(previousYearBalance) > parseFloat(previousYearTotalClaimed))? parseFloat(previousYearTotalClaimed) : parseFloat(previousYearBalance);

  }

  claimTotals.totalPayableAmount = parseFloat(claimTotals.payableAmount) + parseFloat(claimTotals.previousYearPayableAmount);

  if(parseFloat(adminFee) > 0) claimTotals.adminFeeAmount = (claimTotals.totalPayableAmount * adminFee/100);

  if(parseFloat(gst) > 0) claimTotals.gstAmount = (claimTotals.adminFeeAmount * gst/100);

  if(parseFloat(hst) > 0) claimTotals.hstAmount = (claimTotals.adminFeeAmount * hst/100);

  if(parseFloat(rst) > 0) claimTotals.rstAmount = (claimTotals.totalPayableAmount * rst/100);

  if(parseFloat(pst) > 0) claimTotals.pstAmount = ((claimTotals.totalPayableAmount + claimTotals.adminFeeAmount) * pst/100);

  if(parseFloat(prem) > 0) claimTotals.premAmount = ((claimTotals.totalPayableAmount + claimTotals.adminFeeAmount) * prem/100);

  claimTotals.totalAmount = (claimTotals.totalPayableAmount + claimTotals.adminFeeAmount + claimTotals.gstAmount + claimTotals.hstAmount + claimTotals.rstAmount + claimTotals.pstAmount + claimTotals.premAmount);

  return claimTotals;

}

/* -------------------------------------------------------------------------------------- */
export const CalculateWellnessClaim = ( balance, totalClaimed ) => {

  let claimTotals = {
    payableAmount: 0,
    adminFeeAmount: 0,
    totalPayableAmount: 0,
    coPayAmount: 0,
    gstAmount: 0,
    hstAmount: 0,
    rstAmount: 0,
    pstAmount: 0,
    premAmount: 0,
    totalAmount: 0
  };

  claimTotals.payableAmount = (parseFloat(balance) > parseFloat(totalClaimed))? parseFloat(totalClaimed) : parseFloat(balance);

  claimTotals.totalPayableAmount = claimTotals.payableAmount;

  claimTotals.totalAmount = (claimTotals.payableAmount + claimTotals.adminFeeAmount + claimTotals.gstAmount + claimTotals.hstAmount + claimTotals.rstAmount + claimTotals.pstAmount + claimTotals.premAmount);

  return claimTotals;

}

/*----------------------------- Functions ----------------------------------*/
export const isValidInput = (input) => {
    return input && input !== 'undef';
}

export const isNotEmptyInput = (input) => {
    return input && input.trim() !== '';
}

export const cleanedSelectInput = (input) => {
    return (input)? input : "0";
}

export const HSAEmptyDefaultZero = (input) => {
    return (input)? input : "0";
}

export const isTrue = (input) => {
    return input === true || (input === 1 || HSALower(input).includes('true') || HSALower(input).startsWith('y'));
}
export const isFalse = (input) => {
    return input === false || (input === 0 || HSALower(input).includes('false') || HSALower(input).startsWith('n'));
}

export const inArray = (haystack, needle) => {
  return (haystack.indexOf(needle) === -1)? false : true;
}

export function formatBytes(a,b=2){if(0===a)return"0 Bytes";const c=0>b?0:b,d=Math.floor(Math.log(a)/Math.log(1024));return parseFloat((a/Math.pow(1024,d)).toFixed(c))+" "+["Bytes","KB","MB","GB","TB","PB","EB","ZB","YB"][d]}

/*----------------------------- Format Functions ----------------------------------*/
export function TelephoneFormat(telephone) {
    var onlyNum = ('' + telephone).replace(/\D/g, '')
    var formatted = onlyNum.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
    if (formatted) {
        var naCheck = (formatted[1] ? '+1 ' : '')
        return [naCheck, '(', formatted[2], ') ', formatted[3], '-', formatted[4]].join('')
    }
    return '';
}

/*----------------------------- Format Functions ----------------------------------*/
export function HSAMoneyFormat(number){
    if( !number ){
        return '$0.00';
    }
    number = number.toString().replace(/[,$]/g, '');
    let value_money = parseFloat(number).toFixed(2);
    let moneyFormatted = "$0.00";
    if( !isNaN(value_money) ){
        moneyFormatted = "$" + value_money.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        moneyFormatted = moneyFormatted.toString().replace('$-', '-$');
    }
    return moneyFormatted;
}

/*----------------------------- Format Functions ----------------------------------*/
export function HSAMoneyValue(number){
    number = parseFloat(number);
    if( isNaN(number) ){
        return number.toFixed(2);
    }
    return 0.00;
}

/*----------------------------- Format Functions ----------------------------------*/
export function HSAMoneyAdd(number1, number2){
    let value_money = parseFloat(number1) + parseFloat(number2);
    value_money = parseFloat(value_money.toFixed(2));
    if( isNaN(value_money) ){
        return 0.00;
    }
    return value_money;
}

/*----------------------------- Format Functions ----------------------------------*/
export function HSAIntFormat(number){
    let value_int = parseInt(number);
    if( !isNaN(value_int) ){
        return value_int;
    }
    return 0;
}

/*----------------------------- Format Functions ----------------------------------*/
export function HSAFloatFormat(number){
    let value_float= parseFloat(String(number).replace(/[,$]/g, ''));
    if( !isNaN(value_float) ){
        return value_float;
    }
    return 0;
}

/*----------------------------- Format Functions ----------------------------------*/

export function HSADateFormatMonthDayOnly(value){
    if(value instanceof Date){
        return abriv_months[value.getMonth()] + ' ' + value.getDate();
    }
    if (Validate(value, 'isISOFormat')){
        var value_split = String(value).split('-');
        if(value_split.length > 2){
            value_split[1] -= 1;
            return abriv_months[value_split[1]] + ' ' + value_split[2];
        }
    }
    if (Validate(value, 'isMonthDay')){
        var value_split = String(value).split('-');
        if(value_split.length > 1){
            value_split[0] -= 1;
            return abriv_months[value_split[0]] + ' ' + value_split[1];
        }
    }
    return value;
}

/*-----------------------------------------------------------------------*/
export function HSATimeAgo(time){
    switch (typeof time) {
        case 'number':
            break;
        case 'string':
            time = +new Date(time); //new Date as a number
            break;
        case 'object':
            if (time.constructor === Date) time = time.getTime();
            break;
        default:
            time = +new Date();
    }
    var time_formats = [
        [60, 'seconds', 1],
        [120, '1 minute ago', '1 minute from now'],
        [3600, 'minutes', 60],
        [7200, '1 hour ago', '1 hour from now'],
        [86400, 'hours', 3600],
        [172800, 'Yesterday', 'Tomorrow'],
        [604800, 'days', 86400], 
        [1209600, 'Last week', 'Next week'],
        [2419200, 'weeks', 604800], 
        [4838400, 'Last month', 'Next month'], 
        [29030400, 'months', 2419200], 
        [58060800, 'Last year', 'Next year'], 
        [2903040000, 'years', 29030400], 
        [5806080000, 'Last century', 'Next century'],
        [58060800000, 'centuries', 2903040000]
    ];
    var seconds = (+new Date() - time) / 1000,
        token = 'ago',
        list_choice = 1;
    
    if (seconds == 0) {
        return 'Just now'
    }
    if (seconds < 0) {
        seconds = Math.abs(seconds);
        token = 'from now';
        list_choice = 2;
    }
    var i = 0,
        format;
    while (i < time_formats.length){
        format = time_formats[i++];
        if (seconds >= format[0]) continue;
        if (typeof format[2] == 'string')
            return format[list_choice];
        else
            return Math.floor(seconds / format[2]) + ' ' + format[1] + ' ' + token;
    }
    return time;
}
/*-----------------------------------------------------------------------*/
export function HSADate(initDate){
    var utcMidnightDateObj = null
    // if no date supplied, use Now.
    if(!initDate)
        initDate = new Date();

    // if initDate specifies a timezone offset, or is already UTC, just keep the date part, reflecting the date _in that timezone_
    if(typeof initDate === "string" && initDate.match(/(-\d\d|(\+|-)\d{2}:\d{2}|Z)$/gm)){  
        utcMidnightDateObj = new Date( initDate.substring(0,10) + 'T00:00:00Z');
    } else {
        // if init date is not already a date object, feed it to the date constructor.
        if(!(initDate instanceof Date))
        initDate = new Date(initDate);
        // Vital Step! Strip time part. Create UTC midnight dateObj according to local timezone.
        utcMidnightDateObj = new Date(Date.UTC(initDate.getFullYear(),initDate.getMonth(), initDate.getDate()));
    }

    return {
        toISOString:()=>utcMidnightDateObj.toISOString(),
        getUTCDate:()=>utcMidnightDateObj.getUTCDate(),
        getUTCDay:()=>utcMidnightDateObj.getUTCDay(),
        getUTCFullYear:()=>utcMidnightDateObj.getUTCFullYear(),
        getUTCMonth:()=>utcMidnightDateObj.getUTCMonth(),
        setUTCDate:(arg)=>utcMidnightDateObj.setUTCDate(arg),
        setUTCFullYear:(arg)=>utcMidnightDateObj.setUTCFullYear(arg),
        setUTCMonth:(arg)=>utcMidnightDateObj.setUTCMonth(arg),
        addDays:(days)=>{
        utcMidnightDateObj.setUTCDate(utcMidnightDateObj.getUTCDate + days)
        },
        toString:()=>utcMidnightDateObj.toString(),
        toLocaleDateString:(locale,options)=>{
        options = options || {};
        options.timeZone = "UTC";
        locale = locale || "en-EN";
        return utcMidnightDateObj.toLocaleDateString(locale,options)
        }
    }
}

/*-----------------------------------------------------------------------*/
export function HSADateFormat(value){
    if (!value){
        return '';
    }
    let value_date = new Date(value);

    if (Validate(value, 'isISOFormat')){
        var value_split = value.split("-");
        if(value_split.length != 3) return '';
        return abriv_months[parseInt(value_split[1])-1] + ' ' + value_split[2] + ', ' + value_split[0];
    }

    if( !isNaN(value_date) ){
        return abriv_months[value_date.getMonth()] + ' ' + value_date.getDate() + ', ' + value_date.getFullYear();
    }
    return '';
}

/*-----------------------------------------------------------------------*/
export function HSANextRenewalDateFormat(value, isoFormat=false){
    let plan_year_date = HSANextRenewalDate(value)
    return abriv_months[plan_year_date.getUTCMonth()] + ' ' + plan_year_date.getUTCDate() + ', ' + plan_year_date.getUTCFullYear()
}

/*-----------------------------------------------------------------------*/
export function HSANextRenewalDate(value){
    if(!value) return '';
    const today = new Date();

    if (Validate(value, 'isMonthDay')){
        value = today.getFullYear() +'-'+ value;
    }

    if (Validate(value, 'isMonthAbbrDay')){
        let split_value = value.split("-")
        let month = ("0"+(abriv_months.findIndex((element) => element == split_value[0].substring(0,3))+1)).substring(-2)
        let day = split_value[1]
        value = today.getFullYear() +'-'+ month + '-'+day;
    }

    let plan_year_date = new Date(value);
    plan_year_date.setFullYear(today.getFullYear());
    if(today >= plan_year_date){
        plan_year_date.setFullYear(today.getFullYear() + 1);
    }

    return plan_year_date;
}

/*-----------------------------------------------------------------------*/
export function HSAPrevRenewalDate(value){
    if(!value) return '';
    const today = new Date();

    if (Validate(value, 'isMonthDay')){
        value = today.getFullYear() +'-'+ value;
    }

    if (Validate(value, 'isMonthAbbrDay')){
        let split_value = value.split("-")
        let month = ("0"+(abriv_months.findIndex((element) => element == split_value[0].substring(0,3))+1)).substring(-2)
        let day = split_value[1]
        value = today.getFullYear() +'-'+ month + '-'+day;
    }

    let plan_year_date = new Date(value);
    plan_year_date.setFullYear(today.getFullYear());
    if(today < plan_year_date){
        plan_year_date.setFullYear(today.getFullYear() - 1);
    }

    return plan_year_date;
}

/*-----------------------------------------------------------------------*/
export function HSANextPYEDateFormat(value){
    if(!value) return '';
    let plan_year_date = new Date(new Date().getFullYear() + '-' +  value);
    return HSANextRenewalDateFormat(plan_year_date);
}

/*----------------------------- Format Functions ----------------------------------*/
export function HSADateObject(value){
    if(value instanceof Date){
        return value;
    }

    let value_date = new Date(value);

    if (Validate(value, 'isISOFormat')){
        value_date = new Date(value_date.setDate(value_date.getDate() + 1));
    }

    return value_date;
}

/*----------------------------- Format Functions ----------------------------------*/
// Ex. Value In: May 18, 2021 or (obj) May 19, 2021 T00:00:01 -> Return Value: 05-19-2021
export function ISODateFormat(value){

    if (Validate(value, 'isISOFormat')){
        return value;
    }

    let value_date = new Date();
    if(isNaN(value) || value === ''){
        if(isNaN(value_date)) return '';
        return value_date.getFullYear() + '-' + ("0" +(value_date.getMonth()+1)).slice(-2) + '-' + ("0" + value_date.getDate()).slice(-2);
    }

    value_date = new Date(value);
    value_date = new Date(value_date.getTime() + 1);

    if( !isNaN(value_date) ){
       return value_date.getFullYear() + '-' + ("0" +(value_date.getMonth()+1)).slice(-2) + '-' + ("0" + value_date.getDate()).slice(-2);
    }
    return '';
}

/*---------------------------------------------------------------------------------*/
// Ex. Value In: 5-19-2021 -> Return Value: May 18, 2021
export function HSADateWithTimeFormat(value){
    let value_date = new Date(value);
    if( !isNaN(value_date) ){
       return abriv_months[value_date.getMonth()] + ' ' + value_date.getDate() + ', ' + value_date.getFullYear();
    }
    return '';
}

export function HSADateObjectFormat(value){
    let value_date = new Date(value);
    if( !isNaN(value_date) ){
        return abriv_months[value_date.getMonth()] + ' ' + value_date.getDate() + ', ' + value_date.getFullYear();
     }
    return '';
}
/*---------------------------------------------------------------------------------*/
// Ex. Value In: 5-19-2021 -> Return Value: May 18
export function DayMonthObjectFormat(value){
    let value_date = new Date(value);
    if( !isNaN(value_date) ){
        return abriv_months[value_date.getMonth()] + ' ' + value_date.getDate();
     }
    return '';
}


export function HSAKeepDate(value1, value2, method){
    let value_date1 = new Date(value1);
    value_date1 = new Date(value_date1.setDate(value_date1.getDate() + 1));
    let value_date2 = new Date(value2);
    value_date2 = new Date(value_date2.setDate(value_date2.getDate() + 1));

    if(value1 instanceof Date){
        value_date1 = value1;
    }
    if(value2 instanceof Date){
        value_date2 = value2;
    }

    if( isNaN(value_date1) || isNaN(value_date2) ){
        return '';
    }

    switch(method){
        case 'min':
            return (value_date1 < value_date2)? value_date1 : value_date2;
        case 'max':
            return (value_date1 > value_date2)? value_date1 : value_date2;
        default:
            return value_date1;
    }
}

/*----------------------------- Format Functions ----------------------------------*/
export function HSALimitPeriodName(value){
    switch (String(value)){
        case '1':
            return HSALimitPeriods['1'].name;
        case '2':
            return HSALimitPeriods['2'].name;
        default:
            return '';
    }
}

/*----------------------------- Format Functions ----------------------------------*/
export function HSADependantRelationshipName(value){
    switch (String(value)){
        case '1001':
            return 'Spouse';
        case '1002':
            return 'Dependent Child';
        case '1003':
            return 'Infirm';
        default:
            return '';
    }
}

/*------------------------- Dependant Functions ----------------------------------*/
export function HSADependantRelationshipMinBirthDate(value){
    var today = new Date();
    switch (String(value)){
        case '1002':
            return new Date(today.setFullYear(today.getFullYear() - 25));
        default:
            return new Date(today.setFullYear(today.getFullYear() - 120));
    }
}
/*------------------------- Dependant Functions ----------------------------------*/
export function HSADependantRelationshipMaxBirthDate(value){
    var today = new Date();
    switch (String(value)){
        case '1001':
            return new Date(today.setFullYear(today.getFullYear() - 18));
        case '1003':
            return new Date(today.setFullYear(today.getFullYear() - 21));
        default:
            return today;
    }
}

/*------------------------- Dependant Functions ----------------------------------*/
export function HSADependantBirthdateInExt(birthdate, relationship){
    switch (String(relationship)){
        case '1002':
            var today = new Date();
            var dateofbirth = new Date(birthdate);
            var lowestDate = new Date(today.setFullYear(today.getFullYear() - 21));
            return dateofbirth <= lowestDate;
        default:
            return false;
    }
}

/*------------------------- Dependant Functions ----------------------------------*/
export function HSADependantBirthdateAllowedExt(birthdate, relationship){
    switch (String(relationship)){
        case '1002':
            var today = new Date();
            var dateofbirth = new Date(birthdate);
            var lowestDate = new Date(today.setFullYear(today.getFullYear() - 20));
            return dateofbirth <= lowestDate;
        default:
            return false;
    }
}

/*------------------------- Employee Functions ----------------------------------*/
export function HSAEmployeeMinBirthDate(planCode=0){
    let today = new Date();
    let maxAge = ([1031,1032,1061,1081,2000].includes(parseInt(planCode)))? 70 : 100;
    return new Date(today.setFullYear(today.getFullYear() - maxAge));
}

/*------------------------- Employee Functions ----------------------------------*/
export function HSAEmployeeMaxBirthDate(){
    var today = new Date();
    return new Date(today.setFullYear(today.getFullYear() - 18));
}

/*------------------------- Date Functions ----------------------------------*/
export function HSADateAddMinute(date, value){
    var datevalue = new Date(date);
    var dateplus = new Date(datevalue.setMinutes(datevalue.getMinutes() + value));
    return dateplus;
}

export function HSADateAddHour(date, value){
    var datevalue = new Date(date);
    var dateplus = new Date(datevalue.setHours(datevalue.getHours() + value));
    return dateplus;
}

export function HSADateAddYear(date, value){
    var datevalue = new Date(date);
    var dateplus = new Date(datevalue.setFullYear(datevalue.getFullYear() + value));
    return dateplus;
}

export function HSADateAddMonth(date, value){
    var datevalue = new Date(date);
    var dateplus = new Date(datevalue.setMonth(datevalue.getMonth() + value));
    return dateplus;
}

export function HSADateAddDay(date, value){
    var datevalue = new Date(date);
    var dateplus = new Date(datevalue.setDate(datevalue.getDate() + value));
    return dateplus;
}

/*------------------------- Date Functions ----------------------------------*/
export function HSANextPYEDate(date){
    return HSANextRenewalDate(date)
}

/*------------------------- Date Functions ----------------------------------*/
export function HSAPrevPYEDate(date){
    return HSAPrevRenewalDate(date);
}

/*------------------------- Dependant Functions ----------------------------------*/
export function HSADependantExtendMaxDate(birthdate){
    var todayPlusOneYear = new Date();
    todayPlusOneYear.setFullYear(todayPlusOneYear.getFullYear() + 1);

    var oldestYearBirthday = new Date(birthdate);
    oldestYearBirthday.setFullYear(oldestYearBirthday.getFullYear() + 25);

    if(todayPlusOneYear < oldestYearBirthday){
        return todayPlusOneYear;
    }
    return oldestYearBirthday;
}

/*----------------------------- Format Functions ----------------------------------*/
export function HSAFormat(value, format){
    switch(format){
        case 'money':
            return HSAMoneyFormat(HSAFloatFormat(value));
        case 'onlyPositiveMoney':
            return (HSAFloatFormat(value) > 0)? HSAMoneyFormat(value) : '$0.00';
        case 'date':
            return HSADateFormat(value);
        case 'idnumber':
            return '#'+HSAIntFormat(value);
        case 'number':
            return HSAIntFormat(value);
        case 'decimal':
            return HSAFloatFormat(value);
        case 'percent':
            return HSAIntFormat(value)+'%';
        case 'phone':
            return TelephoneFormat(value);
        case 'limitperiod':
            return HSALimitPeriodName(value);
        case 'dependentRelationship':
            return HSADependantRelationshipName(value);
        case 'hsaplan':
        case 'plan':
            return getHSAPlanName(value);
        case 'booleanStatus':
            return (value === 'Y')? 'Yes': 'No';
        case 'groupAdmin':
            return (value === 'Y')? 'Yes': '';
        default:
            return String(value).trim();
    }
}

/*----------------------------- Format Functions ----------------------------------*/
export function HSALower(value){
    return String(value).toLowerCase();
}

/*----------------------------- Format Functions ----------------------------------*/
export function HSAUpper(value){
    return String(value).toUpperCase();
}

/*----------------------------- Format Functions ----------------------------------*/
export function HSACapitalize(value) {
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}

/*----------------------------- Format Functions ----------------------------------*/
export function CardExpFormat(month, year){
    var month_format = ("0" + parseInt(month)).slice(-2);
    var year_format = String(year).slice(-2);
    return month_format + '/' + year_format;
}

/*------------------------------ Report Functions --------------------------------*/
export const exportReportData = (reportData, reportHeader, reportTitle, collapseHeader, collapseDataIndex, showSummary, summaryHeader, summaryData, summaryTitle, appendData) => {
    if(!reportData || reportData == null){
        return {
        data: [],
        header: [],
        filename: "Unloaded"
        };
    }

    let newReportData = [];

    const innerCollapseDataIndex = (collapseDataIndex)? collapseDataIndex : 'collapse';

    if(!collapseHeader) newReportData.push(populateHeader(reportHeader));
    for (let reportGroup of Object.values(reportData)) {
        if(collapseHeader) newReportData.push(populateHeader(reportHeader));
        newReportData.push(populateRow(reportGroup, reportHeader));
        if(collapseHeader) {
            newReportData.push(populateHeader(collapseHeader));
            if(reportGroup[innerCollapseDataIndex]){
                for (let reportGroupRow of Object.values(reportGroup[innerCollapseDataIndex])) {
                    newReportData.push(populateRow(reportGroupRow, collapseHeader));
                }
                newReportData.push([]);
            }
        }
    }

    if(showSummary && summaryData){
        newReportData.push(populateDivider(summaryHeader));
        newReportData.push(populateHeaderTitle(summaryTitle));
        newReportData.push(populateDivider(summaryHeader));
        newReportData.push(populateHeader(summaryHeader));
        for (let summaryRow of Object.values(summaryData)) {
            newReportData.push(populateRow(summaryRow, summaryHeader));
        }
        newReportData.push([]);
    }

    if(appendData){
        for (let appendRow of Object.values(appendData)) {
            newReportData.push(populateAppendRow(appendRow));
        }
    }

    return {
        data: newReportData,
        header: [],
        filename: HSAFileNameFormat(reportTitle)+".csv"
    };
};
/*----------------------------- Format Functions ----------------------------------*/
const populateAppendRow = (rowData) => {
    return Object.values(rowData).map( (rowDataEle, h) => {
        return rowDataEle;
    })
}
/*----------------------------- Format Functions ----------------------------------*/
const populateRow = (rowData, rowHeader) => {
    return Object.values(rowHeader).map( (rowHeaderEle, h) => {
        return rowData[rowHeaderEle.key];
    })
}
/*----------------------------- Format Functions ----------------------------------*/
const populateHeader = (rowHeader) => {
    return Object.values(rowHeader).map( (rowHeaderEle, h) => {
        return (rowHeaderEle.label)? '('+rowHeaderEle.label+')': '';
    })
}
/*----------------------------- Format Functions ----------------------------------*/
const populateHeaderTitle = (headerTitle, rowHeader) => {
    return [headerTitle];
}
/*----------------------------- Format Functions ----------------------------------*/
const populateDivider = (rowHeader) => {
    return Object.values(rowHeader).map( (rowHeaderEle, h) => {
        return '-------';
    })
}
/*----------------------------- Format Functions ----------------------------------*/
export const hasHeaderSignal = (value) => {
    return (value)? (String(value).charAt(0) == '(' && String(value).charAt(String(value).length - 1) == ')') : false;
}

/*----------------------------- Changes to MyO EE List ----------------------------------*/
export const IntroChangesMyOEE = [
    {title: 'New MyOlympia Layout', text: 'The "Manage Account" links from our previous layout are now accessible through the left navigation on desktop and the top menu icon on mobile.', img: '/images/tour/old_manage_account.jpg', url: '' },
    {title: 'Resources Section', text: 'All forms and guides previously on the "Manage Account" page are now in a separate searchable "Documents" page.', img: '/images/tour/old_resources.jpg', url: ''}
]

/*----------------------------- Changes to MyO BC List ----------------------------------*/
export const IntroChangesMyOBC = [
    ...IntroChangesMyOEE,
    {title: 'Reports Section', text: 'All company reports previously listed on the "Manage Account" page are now in a separate "Company Reports" page under the "Company" Section.', img: '/images/tour/old_manage_reports.jpg', url: ''},
    {title: 'Company Section', text: 'The "Company" section is for your company information, company plan details, company banking, and company reports.', img: '/images/tour/old_manage_company.jpg', url: ''},
    {title: 'Employees Section', text: 'The "Employees" section is for managing your employees, organizing employee classifications, and defining employee divisions.', img: '/images/tour/old_manage_company.jpg', url: ''},
]

/*----------------------------- Changes to Addons List -----------------------------------*/
export const IntroChangesMyOWellness = [
    {title: 'Wellness Claims Available', text: 'Wellness claims were exclusive to the MyOlympia App and now available on the MyOlympia Portal.', img: '/images/tour/old_claim_system.jpg', url: '' },
];
/*----------------------------- Changes to MyO Agent List ----------------------------------*/
export const IntroChangesMyOAgent = [
    {title: 'New MyOlympia Layout', text: 'The links from our previous layout are now accessible through the left navigation on desktop and the top menu icon on mobile.', img: '/images/tour/old_partner_manage_account.jpg', url: '' },
    {title: 'Resources Section', text: 'All forms and guides previously on the "Manage Account" page are now in a separate searchable "Resources" page.', img: '/images/tour/old_partner_resources.jpg', url: ''}
]
